import './Dashboard.css';

const Dashboard = () => {
  return <div className="dashboard__general"></div>;
};

export default Dashboard;
